<template>
  <el-container>
    <el-aside class="my-aside">
      <div class="title">所有类别</div>
      <div class="search">
        <el-input
          size="small"
          placeholder="搜索类别"
          v-model="keyword"
          @clear="onFilter"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="onFilter"
          ></el-button>
        </el-input>
      </div>
      <div style="overflow-y: auto; height: 500px" class="m-scroll">
        <el-tree
          ref="tree"
          :data="types"
          node-key="RecordId"
          :filter-node-method="onFilterFunc"
          default-expand-all
          :props="defaultProps"
          check-on-click-node
          :expand-on-click-node="false"
          @node-click="onSelect"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span :class="{ 'current-node': node.isCurrent }">{{
              node.label
            }}</span>
          </span>
        </el-tree>
      </div>
    </el-aside>
    <el-main class="my-main">
      <div class="row header">
        <span style="color: #909399">类别信息</span>
        <div>          
          <!-- <el-button
            type="success"
            v-if="$permission.canWrite() && loginInfo.UserType == 1"
            @click="onMoreAdd"
            >批量添加平台商品类别</el-button
          >
          <el-button
            type="success"
            v-if="$permission.canWrite() && loginInfo.UserType == 1"
            @click="onAdd"
            >一键添加平台商品类别</el-button
          > -->
          <el-button
            type="primary"
            v-if="$permission.canWrite() && data.TypeLevel < 3&& loginInfo.UserType == 1"
            @click="onCreate"
            icon="el-icon-plus"
            >添加</el-button
          >
          <el-button
            type="danger"
            v-if="$permission.canDel()&& loginInfo.UserType == 1"
            :disabled="data.RecordId <= 0"
            @click="onDelete"
            >删除</el-button
          >
        </div>
      </div>
      <div class="content">
        <el-form
          :model="data"
          :rules="rules"
          ref="form"
          label-width="85px"
          label-position="right"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="类别名称" prop="TypeName">
                <el-input
                  v-model="data.TypeName"
                  placeholder="请填写类别名称"
                  clearable
                  :disabled="loginInfo.UserType == 0"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上级类别">
                <!-- <el-input v-model="data.TypeNameParent" disabled></el-input> -->
                <span style="color: #606266">{{ data.TypeNameParent }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" :disabled="loginInfo.UserType == 0"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State" :disabled="loginInfo.UserType == 0">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="data.RecordId>0&&loginInfo.UserType == 0"><el-col :span="8">
            <el-form-item label="所属商家" prop="BusiName">
                {{data.BusiName}}
              </el-form-item>
            </el-col></el-row>
          <!-- <el-row v-if="data.RecordId>0"><el-col :span="8">
            <el-form-item label="编号" prop="RecordId">
                {{data.RecordId}}
              </el-form-item>
            </el-col></el-row> -->
        </el-form>
      </div>
      <div class="row footer">
        <el-button v-if="canEdit&&loginInfo.UserType == 1" type="primary" @click="onSave"
          >保存</el-button
        >
      </div>
    </el-main>
    <!-- <el-dialog
      v-dialogDrag
      :append-to-body="false"
      title="一键添加"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form>
        <el-row v-if="loginInfo.UserType == 0">
          <el-col :span="24">
            <el-form-item label="所属门店" prop="StoreId" label-width="100px">
              <store-select v-model="storeId" ref="storeSelect"></store-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
    <add-dialog ref="addDialog" @close-saved="onReload"></add-dialog>
    <more-dialog ref="moreDialog" @close-saved="onReload"></more-dialog>
  </el-container>
</template>
<script>
import addDialog from "./addDialog";
import moreDialog from "./moreDialog";
export default {
  components: {
    addDialog,
    moreDialog
  },
  data() {
    return {
      api: require("@/api/goods/type").default,
      keyword: "",
      types: [],
      defaultProps: {
        children: "children",
        label: "TypeName",
      },
      data: {
        RecordId: 0,
        OrderId: 0,
        TypeName: "",
        TypeLevel: 0,
        TypeIdParent: null,
        TypeNameParent: "",
        State: 1,
      },
      canEdit: false,
      rules: {
        TypeName: [{ required: true, message: "类别名称不能为空" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      dialogVisible: false,
    };
  },
  mounted() {
    this.canEdit = this.$permission.canEdit();
    this.onReload();
  },
  methods: {
    onMoreAdd() {
      console.log("onMoreAdd",this.$refs);
      this.$refs.moreDialog.types=[];
      this.$refs.moreDialog.topRow.Checked=false;
      this.$refs.moreDialog.checkedIds=[];
      this.$refs.moreDialog.onReload();
      this.$refs.moreDialog.open(); 
      
    },
    onAdd() {
      console.log("onAdd",this.$refs);
      //this.$refs.addDialog.open(); 
       this.$confirm("确认一键添加平台商品类别吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var loading = this.$loading({
              lock: true,
              text: "正在添加...",
              spinner: "el-icon-loading",
              customClass: "my_loading",
              background: "rgba(0, 0, 0, 0.3)",
            });
            this.api.oneSave().then((res) => {
              loading.close();
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                this.onReload();
              
              } else {
                this.$message.error(res.Msg);
              }
            });
          })
          .catch(() => {});
      
    },
    onReload() {
      this.api.list({}).then((res) => {
        if (res.Code == 0) {
          var root = {
            RecordId: -1,
            OrderId: 0,
            TypeName: "商品分类",
            TypeLevel: 0,
            TypeIdParent: null,
            TypeNameParent: "",
            State: 1,
          };
          this.types = this.$commonJs.toTreeData(
            res.Data,
            "RecordId",
            "TypeIdParent",
            "children",
            root
          );
          console.log("types", this.types);

          this.$nextTick(() => {
            if (this.data.RecordId > 0) {
              this.$refs.tree.setCurrentKey(this.data.RecordId);
            } else {
              this.$refs.tree.setCurrentKey(-1);
            }
          });
        }
      });
    },
    onFilter() {
      this.$refs.tree.filter(this.keyword);
    },
    onFilterFunc(value, data) {
      if (!value) return true;
      return data.TypeName.indexOf(value) !== -1;
    },
    onSelect(data) {
      console.log("onSelect", JSON.parse(JSON.stringify(data)));

      var initData = this.$options.data().data;
      this.data = { ...initData };

      if (data.RecordId == -1) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });

        this.api.getMaxOrderId().then((res) => {
          if (res.Code == 0) this.data.OrderId = res.Data;
        });
      } else {
        this.data = { ...data };
      }
    },
    onCreate() {
      var data = { ...this.data }; //取出原类别数据
      var initData = this.$options.data().data;
      this.data = { ...initData }; //初始化

      var pid = 0;
      if (data.RecordId > 0) {
        //新类别填入上级类别信息
        this.data.TypeIdParent = pid = data.RecordId;
        this.data.TypeNameParent = data.TypeName;
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });

      this.api.getMaxOrderId(pid).then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onDelete() {
      if (this.data.RecordId > 0) {
        this.$confirm("确认删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var loading = this.$loading({
              lock: true,
              text: "正在删除...",
              spinner: "el-icon-loading",
              customClass: "my_loading",
              background: "rgba(0, 0, 0, 0.3)",
            });
            this.api.delete({ Id: this.data.RecordId }).then((res) => {
              loading.close();
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                var initData = this.$options.data().data;
                this.data = { ...initData };
                this.$nextTick(() => {
                  this.$refs.form.clearValidate();
                });
                var node = this.$refs.tree.getCurrentNode(); //获取当前节点
                // console.log("node", node);
                this.$refs.tree.remove(node); //移除节点
                var pid = node.TypeIdParent;
                var parentNode = this.$refs.tree.getNode(pid == 0 ? -1 : pid); //获取父节点
                this.$nextTick(() => {
                  this.$refs.tree.setCurrentKey(node.TypeIdParent); //设置选中父节点
                  this.onSelect(parentNode.data); //选择父节点
                });
              } else {
                this.$message.error(res.Msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    onSave() {
      console.log("data", JSON.parse(JSON.stringify(this.data)));
      // return;
      this.$refs.form
        .validate()
        .then((res) => {
          if (!res) return false;

          var loading = this.$loading({
            lock: true,
            text: "正在保存...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });

          var data = this.$commonJs.obj.removeNullKey(this.data);
          this.api.save(data).then((res) => {
            loading.close();
            if (res.Code == 0) {
              this.data.RecordId = res.Data;
              this.$message.success(res.Msg);
              var pid = this.data.TypeIdParent||0;
             // console.log(pid,"pid")
              var parentNode = this.$refs.tree.getNode(pid == 0 ? -1 : pid); //获取父节点
              // console.log("parentNode", parentNode);
              var node = this.$refs.tree.getNode(res.Data); //根据RecordId获取节点
               //console.log("node", node);
              //判断节点是否存在，存在则更新，不存在则添加
              if (node) {
                node.data.TypeName = data.TypeName;
                node.data.OrderId = data.OrderId;
                node.data.State = data.State;
              } else {
                this.$refs.tree.append(this.data, parentNode);
              }
              //节点排序
              var childNodes = parentNode.childNodes.sort((a, b) => {
                return a.data.OrderId - b.data.OrderId;
              });
              // console.log("childNodes", childNodes);
              parentNode.childNodes = childNodes;
              this.$nextTick(() => {
                //设置选中的节点
                this.$refs.tree.setCurrentKey(this.data.RecordId);
              });
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-aside {
  width: 260px !important;
  padding: 0;
  margin: 0;
  background-color: white;
  border: 1px solid #dedede;

  .title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #dedede;
    margin-bottom: 5px;
    color: #909399;
  }

  .search {
    padding: 0 8px;
    margin-bottom: 5px;
  }
}

.my-main {
  padding: 0;
  border: 1px solid #dedede;
  border-left: none;

  .row {
    padding: 0 5px;
    height: 40px;
    display: flex;
    align-items: center;
  }

  .header {
    border-bottom: 1px solid #dedede;
    justify-content: space-between;
  }

  .content {
    height: 500px;
    padding: 10px 5px;
  }

  .footer {
    border-top: 1px solid #dedede;
    justify-content: flex-end;
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 40px;
  padding-right: 8px;
}

.current-node {
  color: #409eff;
}
</style>